/*
 * パスワード再発行（api create）
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_USER_PASSWORD_RESET = 'API_CREATE_USER_PASSWORD_RESET';
export const API_CREATE_USER_PASSWORD_RESET_SUCCESS = 'API_CREATE_USER_PASSWORD_RESET_SUCCESS';
export const API_CREATE_USER_PASSWORD_RESET_FAILURE = 'API_CREATE_USER_PASSWORD_RESET_FAILURE';
/**
 * パスワード再発行
 * @param data
 * @param meta
 * @returns
 */
export const apiCreateUserPasswordReset = ({ json }, meta) => apiCreate(API_CREATE_USER_PASSWORD_RESET, '/user/password_reset', json, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
